import { useState } from "preact/hooks"
import { DistributorSalesSection } from "../sales_forecasting/components/distributor_sales_section"
import { SpinsSalesSection } from "./spins_sales_section"
import { SalesWizPanel } from "./sales_wiz_panel"
import { KeheSupplySection } from "./kehe_supply/kehe_supply_section"
import { Button } from "../../components/ui/button"

type SalesAnalysisMode = "distributor" | "kehe_supply" | "mclane" | "spins" | "chains"

const MODES: { value: SalesAnalysisMode; label: string }[] = [
  { value: "distributor", label: "KeHE" },
  { value: "kehe_supply", label: "KeHE Supply" },
  { value: "mclane", label: "McLane" },
  { value: "spins", label: "Syndicated Data" },
  { value: "chains", label: "Chains" },
]

function ModeToggle(props: { mode: SalesAnalysisMode; onChange: (mode: SalesAnalysisMode) => void }) {
  return (
    <div class="flex rounded-md border border-gray-200 bg-white p-1">
      {MODES.map(({ value, label }) => (
        <Button
          key={value}
          variant={props.mode === value ? "default" : "ghost"}
          size="sm"
          onClick={() => props.onChange(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

/**
 * Ask-about-chains. Unlike the other two modes this one reads no uploaded report — it answers from
 * the shared retail chain catalog, so it works before any data has been loaded for the brand.
 */
function ChainsSection() {
  return (
    <div class="space-y-4">
      <div>
        <h2 class="text-lg font-semibold text-gray-900">Ask about chains</h2>
        <p class="mt-1 text-sm text-gray-600">
          How a retailer actually operates — category review schedule and whether brands can attend, ad, TPR, end cap,
          demo and slotting fees, merchandising and POG policy, headquarters and store count. Industry knowledge about
          the retailer, not your account terms.
        </p>
      </div>
      <SalesWizPanel />
    </div>
  )
}

function SectionForMode({ mode }: { mode: SalesAnalysisMode }) {
  switch (mode) {
    case "spins":
      return <SpinsSalesSection />
    case "chains":
      return <ChainsSection />
    case "kehe_supply":
      return <KeheSupplySection />
    case "mclane":
      return <DistributorSalesSection key="mclane" source="mclane" />
    default:
      return <DistributorSalesSection key="kehe" source="kehe" />
  }
}

export function SalesAnalysis(props: any) {
  const { className } = props
  const [mode, setMode] = useState<SalesAnalysisMode>("distributor")

  return (
    <div className={`space-y-6 px-6 ${className || ""}`}>
      <div class="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 class="text-2xl font-semibold text-gray-900">Sales Analysis</h1>
          <p class="mt-1 text-sm text-gray-600">
            Analyze KeHE and McLane sales reports, syndicated category data, SKU trends, retailer performance, and competitive growth.
          </p>
        </div>
        <ModeToggle mode={mode} onChange={setMode} />
      </div>
      <SectionForMode mode={mode} />
    </div>
  )
}
